import React from 'react';
import './App.css';
import AccountCreate from './scenes/Account/AccountCreate';

function App() {
  
  return (
    <div className="App container">
      <AccountCreate />
    </div>
  );
}

export default App;
